<template>
  <div class="w-full">
    <SuccessButton
    :disabled="!$atividades.permissoes.includes(14)"
      class="mr-6"
      @func="modalCadastroArea = true"
    ></SuccessButton>
    <SideBar
      title="Cadastrar area"
      @hide="modalCadastroArea = false"
      size="small"
      :active="modalCadastroArea"
      @success="submitForm()"
    >
      <div slot="body">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx w-full"
              v-validate="'required'"
              name="nome"
              label-placeholder="Nome"
              v-model="area.nome"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  name: "ModalCadastroArea",
  data() {
    return {
      area: {},
      modalCadastroArea: false,
      error: false
    };
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.cadastrarArea();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async cadastrarArea() {
      this.$vs.loading();
      try {
        const res = await this.$http.post("area", this.area);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: 'cadastrar',
          setor: 'comercial',
          ip: window.localStorage.getItem("ip"),
          texto: 'Cadastro da área N°' + res.id}
        await this.$logger(logData)
        this.$vs.notify(this.$notify.Success);
        this.modalCadastroArea = false;
        this.area = {};
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$emit("update");
        this.$vs.loading.close();
      }
    }
  },
  components: components
};
</script>

<style></style>
